/**
 * Утилиты оболочки tenant-app: инициалы аватара и человекочитаемая роль.
 *
 * Используются и в сайдбаре (карточка пользователя внизу), и на экране
 * «Профиль» (§2.2): аватар-инициалы + бейдж роли.
 */
import type { ActorRole } from '../../shared/api/platform-me.js';
import type { DashboardKind } from '../../shared/nav/resolve-role.js';

/**
 * Инициалы из ФИО: первые буквы первых двух слов (напр. «Артём Орлов» →
 * «АО»). Пустое имя → «—». Регистр приводится к верхнему.
 */
export function initials(name: string): string {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);
  if (parts.length === 0) return '—';
  return parts.map((p) => p[0]!.toUpperCase()).join('');
}

/** RU-лейбл роли по типу дашборда (для бейджа/подписи пользователя). */
export const ROLE_LABEL: Readonly<Record<DashboardKind, string>> = {
  owner: 'Владелец',
  manager: 'Менеджер',
  staff: 'Персонал',
  guest: 'Гость',
};

/** Точный RU-лейбл по сырой роли бэкенда — для бейджа профиля. */
export function roleLabel(role: ActorRole): string {
  switch (role) {
    case 'tenant_owner':
    case 'owner':
      return 'Владелец';
    case 'hotel_manager':
    case 'manager':
      return 'Hotel manager';
    case 'front_desk':
      return 'Администратор';
    case 'housekeeper':
      return 'Уборщица';
    case 'maintenance':
      return 'Техобслуживание';
    case 'restaurant':
      return 'Ресторан / бар';
    case 'vendor_buyer':
    case 'vendor':
      return 'Поставщик';
    case 'guest':
      return 'Гость';
    default:
      return 'Сотрудник';
  }
}
